import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { ChargeNumberManagement } from './charge-number-management.model';
import { IContractManagement } from '../IContractManagement';
import { IChargeNumberManagement } from '../IChargeNumberManagement';
import { IContract } from '../presenters/contract-management-presenters.component';

export const getChargeNumbers = createAction(
  '[ChargeNumberManagement/API] Get Charge Numbers',
  props<{ Contract: IContract }>()
);

export const putChargeNumbers = createAction(
  '[ChargeNumberManagement/API] Update Charge Numbers',
  props<{ chargeNumbers: Array<IChargeNumberManagement>, Activeonly?: boolean }>()
);

export const loadChargeNumberManagements = createAction(
  '[ChargeNumberManagement/API] Load ChargeNumberManagements',
  props<{ chargeNumberManagements: IChargeNumberManagement[] }>()
);

export const addChargeNumberManagement = createAction(
  '[ChargeNumberManagement/API] Add ChargeNumberManagement',
  props<{ chargeNumberManagement: IChargeNumberManagement }>()
);

export const upsertChargeNumberManagement = createAction(
  '[ChargeNumberManagement/API] Upsert ChargeNumberManagement',
  props<{ chargeNumberManagement: IChargeNumberManagement }>()
);

export const addChargeNumberManagements = createAction(
  '[ChargeNumberManagement/API] Add ChargeNumberManagements',
  props<{ chargeNumberManagements: IChargeNumberManagement[] }>()
);

export const upsertChargeNumberManagements = createAction(
  '[ChargeNumberManagement/API] Upsert ChargeNumberManagements',
  props<{ chargeNumberManagements: IChargeNumberManagement[] }>()
);

export const updateChargeNumberManagement = createAction(
  '[ChargeNumberManagement/API] Update ChargeNumberManagement',
  props<{ chargeNumberManagement: Update<IChargeNumberManagement> }>()
);

export const updateChargeNumberManagements = createAction(
  '[ChargeNumberManagement/API] Update ChargeNumberManagements',
  props<{ chargeNumberManagements: Update<IChargeNumberManagement>[] }>()
);

export const deleteChargeNumberManagement = createAction(
  '[ChargeNumberManagement/API] Delete ChargeNumberManagement',
  props<{ id: string }>()
);

export const deleteChargeNumberManagements = createAction(
  '[ChargeNumberManagement/API] Delete ChargeNumberManagements',
  props<{ ids: string[] }>()
);

export const clearChargeNumberManagements = createAction(
  '[ChargeNumberManagement/API] Clear ChargeNumberManagements'
);
